import { useEffect, useState } from 'react';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Swal from 'sweetalert2';
import './style.css';
import { useTranslation } from 'react-i18next';

const UserAdmin = () => {
    const { t } = useTranslation();
    const [suppliers, setSuppliers] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [deviationBonus, setDeviationBonus] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [deletedSuppliers, setDeletedSuppliers] = useState(new Set()); // Track deleted suppliers
const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        checkAdminStatus();
    }, []);

    useEffect(() => {
        if (isAdmin) {
            fetchAllSuppliers();
        }
    }, [currentPage, isAdmin]);

    const checkAdminStatus = () => {
        const isAdmin = localStorage.getItem('isAdmin') === '1';
        setIsAdmin(isAdmin);
        if (isAdmin) {
            fetchAllSuppliers();
        } else {
                return;
        }
    };

    const fetchAllSuppliers = async () => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                return;
            }

            const response = await axios.get(`  https://plateformewmg.cloud/api/admin/users?page=${currentPage}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                setSuppliers(response.data.data); // Suppliers data
                setTotalPages(response.data.last_page); // Total pages from API response
            } else {
                return;
            }
        } catch (error) {
                return;
        }
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    if (!isAdmin) {
        return <p className="text-danger text-center">Unauthorized: You do not have admin access.</p>;
    }
const filteredSuppliers = suppliers.filter(supplier =>
  (supplier.name?.toLowerCase().includes(searchTerm.toLowerCase())) ||
  (supplier.custom_id?.toLowerCase().includes(searchTerm.toLowerCase()))
);

    const banUser = async (supplierId) => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await axios.delete(
                `  https://plateformewmg.cloud/api/admin/user/${supplierId}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                // Update the deletedSuppliers state to include the deleted supplier ID
                setDeletedSuppliers((prev) => new Set(prev.add(supplierId)));
                Swal.fire("Success", "Utilisateur supprimé avec succés!", "success");
                fetchAllSuppliers(); // Refresh the supplier list
            } else {
                Swal.fire("Error", "échec de la suppression", "error");
            }
        } catch (error) {
            Swal.fire("Error", error.response?.data || "Something went wrong", "error");
            fetchAllSuppliers(); // Refresh supplier list in case of error
        }
    };

   const ActiverUserAccount = async (supplierId) => {
    console.log(supplierId);
        try {
            const token = localStorage.getItem('authToken');
            const response = await axios.put(
  `https://plateformewmg.cloud/api/admin/activerUser/${supplierId}`,
  {}, // no request body needed
  {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  }
);


            if (response.status === 200) {
                // Update the deletedSuppliers state to include the deleted supplier ID
                Swal.fire("Success", "Utilisateur activer avec succés!", "success");
                fetchAllSuppliers(); // Refresh the supplier list
            } else {
                Swal.fire("Error", "échec d'activer cette compte", "error");
            }
        } catch (error) {
            Swal.fire("Error", error.response?.data || "Something went wrong", "error");
            fetchAllSuppliers(); // Refresh supplier list in case of error
        }
    };
const handleSendPromotion = async () => {
        // 1. Show confirmation dialog using Swal before proceeding
        const result = await Swal.fire({
            title: t('Confirmation'),
            text: t('Voulez-vous vraiment envoyer la promotion WhatsApp à tous les clients?'), // You can change this to a French translation key
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('Oui, envoyer!'), // "Yes, send it!"
            cancelButtonText: t('Annuler') // "Cancel"
        });

        // 2. Proceed only if the user confirms
        if (result.isConfirmed) {
            try {
                const token = localStorage.getItem('authToken');
                
                // IMPORTANT: This API URL must match the new route you create in Laravel
                const response = await axios.post(
                    `https://plateformewmg.cloud/api/admin/send-promotion`,
                    {}, // POST request data is empty since the backend fetches all clients
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`, // Pass the authentication token
                        },
                    }
                );

                if (response.status === 200) {
                    Swal.fire("Succès", t('Promotion envoyée aux numéros test.'), "success");
                } else {
                    Swal.fire("Erreur", t('Échec de l\'envoi de la promotion.'), "error");
                }

            } catch (error) {
                // Handle 401 Unauthorized, 403 Forbidden, or other errors
                Swal.fire("Erreur", error.response?.data?.message || t("Une erreur s'est produite lors de la connexion au serveur."), "error");
            }
        }
    };
    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div className="d-flex flex-column flex-md-row">
                <section className="w-100 p-3">
  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
    <h1 className="text-dark display-4 m-0">{t('Tableau_de_bord_Utilisateurs')}</h1>
    <button
            style={{ backgroundColor: '#edbf03', color: 'white' }} /* Use a highly visible color */
            className="btn btn-lg"
            onClick={handleSendPromotion}
        >
            {t('Envoyer_un_whatsapp')}
        </button>
    <input
        type="text"
        className="form-control w-auto"
  placeholder={t('Rechercher_par_nom_id')}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ maxWidth: '300px' }}
    />
</div>
                    <hr className="my-4" />

                    {/* Suppliers Table */}
                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead className="table-primary">
                                <tr>
                                    <th>{t('Identifiant')}</th>
                                    <th>{t('Nom')}</th>
                                    <th>{t('Email')}</th>
                                    <th>{t('Numéro_de_Téléphone')}</th>
                                    <th>{t('Adresse')}</th>
                                    <th>{t('created_at')}</th>
                                    <th>{t('Role')}</th>
                                    <th>{t('Actions')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredSuppliers.map((supplier) => (
                                    <tr key={supplier.id}>
                                        <td>{supplier.custom_id}</td>
                                        <td>{supplier.name}</td>
                                        <td>{supplier.email}</td>
                                        <td>{supplier.phone}</td>
                                        <td>{supplier.address}</td>
                                                    <td>{new Date(supplier.created_at).toLocaleString()}</td>

<td>
    {supplier.role === 'supplier' ? 'Distributeur' : supplier.role ?? 'Aucun rôle'}
</td>                                     
   <td>
                                        <button
    style={{ backgroundColor: '#133b8c' ,color:'white'}}

                    className="btn"
                    onClick={() => banUser(supplier.id)}
                    disabled={supplier.is_deleted} // Disable the button if the user is deleted
                >
                    {t('BAN')}
                </button>
                <button
    style={{ backgroundColor: '#edbf03' ,color:'white'}}

                    className="btn"
                    onClick={() => ActiverUserAccount(supplier.id)}
                   disabled={supplier.compteVerified} // Disable the button if the user is deleted

                >
                    {t('Activer')}
                </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-center">
                        <nav>
                            <ul className="pagination">
                                <li className="page-item" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                                    <button className="page-link">{t('Previous')}</button>
                                </li>
                                {[...Array(totalPages)].map((_, index) => (
                                    <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                                            {index + 1}
                                        </button>
                                    </li>
                                ))}
                                <li className="page-item" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                                    <button className="page-link">{t('Next')}</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </section>
            </div>

    

            <Footer />
        </AnimationRevealPage>
    );
};

export default UserAdmin;
